<script>
import { mapGetters } from 'vuex'
import Filter from './Filter'
export default {
    name: 'Stats',

    computed: {
        ...mapGetters({
            statuses: 'statuses',
            stats: 'statistics',
            filters: 'filters',
            search: 'search',
        }),
    },

    watch: {
        $route: 'fetch',
        search: 'fetch',
        filters: 'fetch',
    },

    mounted() {
        this.fetch()
        this.$store.dispatch('filterComponent', Filter)
    },

    methods: {
        fetch() {
            this.$store.dispatch('statisticsFetch', {
                search: this.search,
                filters: this.filters,
            })
        },
    },
}
</script>
<template lang="pug">
    div
        acrm-panel(v-if="stats && stats.counts")
            div.flex-center-v.w-100(slot="heading")
                acrm-heading(:level="6" grey) {{ $t('STATS.ORDER_STATUS')}}
            .row
                .col-24.col-xl-21
                    .row
                        .col-24.col-sm-12.col-lg-8.col-xl-6(v-for="status in stats.counts")
                            .flex-center-v.mb-2
                                span.status-mark.flex-shrink-0(:style="{backgroundColor: status.color}")
                                span {{ status.name }}
                                strong.ml-auto.mr-2 {{ status.num }}

        acrm-panel.mt-4.stat-panel(v-if="stats && stats.counts" transparent)
            .row
                .col-24.col-md-12.col-lg-6.mb-4.mb-lg-0
                    acrm-panel.m-0
                        div.flex-center-v.w-100(slot="heading")
                            acrm-heading(:level="6" grey) {{ $t('STATS.COMPANY_PROFIT')}}
                        acrm-heading(:level="3") {{ stats.profit | toMoney }}
                .col-24.col-md-12.col-lg-6.mb-4.mb-lg-0
                    acrm-panel.m-0
                        div.flex-center-v.w-100(slot="heading")
                            acrm-heading(:level="6" grey) {{ $t('STATS.EARNING')}}
                        acrm-heading(:level="3") {{ stats.income | toMoney }}
                .col-24.col-md-12.col-lg-6.mb-4.mb-md-0
                    acrm-panel.m-0
                        div.flex-center-v.w-100(slot="heading")
                            acrm-heading(:level="6" grey) {{ $t('STATS.SUCC_ORDERS')}}
                        acrm-heading.flex-center-v(:level="3")
                            icon.c-success-2.mr-1(name="check")
                            | {{ stats.success }} {{ $t('BASE.PIECE') }}
                .col-24.col-md-12.col-lg-6
                    acrm-panel.m-0
                        div.flex-center-v.w-100(slot="heading")
                            acrm-heading(:level="6" grey) {{ $t('STATS.FAILED_ORDERS')}}
                        acrm-heading.flex-center-v(:level="3")
                            icon.c-danger-2.mr-1(name="block")
                            | {{ stats.failed }} {{ $t('BASE.PIECE') }}
</template>
<style lang="scss">
.stat-panel.card {
    > .card-body {
        padding: 0;
    }
}
</style>
